import moment from 'moment-timezone';

export const MAX_EXPIRY_DURATION_DAYS = 90;

export function isDateDisabled(date: Date): boolean {
  if (date <= new Date()) {
    return true;
  }
  return false;
}

export function getDefaultExpiryDate() {
  return moment.utc().add(MAX_EXPIRY_DURATION_DAYS, 'day').endOf('day');
}
